import { VERSION } from '../../environments/version';
import { CryptJsSettingsInAutoAct } from '../../constant/crypt-js-settings';
import { CryptJsManager } from '../share/crypt-js/crypt-js-manager';
import { IAutoAct } from './auto-act-if';
import { AutoActService } from './auto-act.service';
import { environment } from '../../environments/environment';

/** ブラウザが保持するデータをログ出力する処理 */
export class BrowserLogging {
    private http: AutoActService;
    private exceptionCount = 0;
    private latestException: string;

    constructor(private autoActService: AutoActService) {
        this.http = autoActService;
    }

    /** ブラウザが保持する情報をDB出力する */
    // NOTE: データ量が膨大になり、DBへの負荷が大きいため、現在は機能停止している。API側はそのままにしているので今後対応したい。
    // public async postLogAsync(): Promise<IAutoAct.PostBrowserLogsResult> {
    //   try {
    //     this.displayLog('try postLogAsync...');
    //     /* localStorageに暗号化されたSmile9IDがなければ、Angular上「いただきます端末」とはみなさずに自動処理用の値はDB取得させない。
    //     * localStorageの暗号化されたSmile9IDは、カードサインイン時にSmile9ロール＝いただきますの場合にのみ格納される。、 */
    //     let smile9IdWithPrefix = localStorage.getItem('[AutoAct]Smile9ID');
    //     if (!smile9IdWithPrefix || smile9IdWithPrefix === '') {
    //     this.displayLog('*** no smile9ID in localStorage! ***');
    //     return;
    //     }
    //     // localStorageのSmile9IDを復号して利用
    //     smile9IdWithPrefix = CryptJsManager.decrypt(smile9IdWithPrefix, CryptJsSettingsInAutoAct.KEY, CryptJsSettingsInAutoAct.IV);

    //     const model: IAutoAct.BrowserLogs = {
    //       ug_id: localStorage.getItem('[AutoAct]ugId'),
    //       /** smile9ID(Angularで復号して取得) */
    //       smile9Id: smile9IdWithPrefix,
    //       /** JavaScriptの現在時刻 */
    //       jsCurrentDate: new Date().toString(),
    //       /** 表示中のURL */
    //       locationHref: location.href,
    //       /** userAgent */
    //       userAgent: navigator.userAgent,
    //       /** platform */
    //       platform: navigator.platform,
    //       /** Angularのバージョン */
    //       angularVersion: VERSION,
    //       /** localStorageの全て */
    //       localStorage: JSON.stringify(this.createLocalStorageLogs()),
    //       /** sessionStorageの全て */
    //       sessionStorage: JSON.stringify(this.createSessionStorageLogs()),
    //       latestException: this.latestException,
    //       exceptionCount: this.exceptionCount,
    //     };
    //     const res = await this.http.postBrowserLogs(model)
    //       .catch(err => {
    //           // 例外の場合はその情報を記憶しておき、次回のログ出力時に吐かせる
    //           this.exceptionCount++;
    //           if (err) {
    //               this.latestException = JSON.stringify(err);
    //           } else {
    //               this.latestException = null;
    //           }
    //           console.error(err);
    //       });
    //     if (res) {
    //       this.displayLog(`postBrowserLogs result: ${res?.result}`);
    //       // 成功の場合は例外情報をリセット
    //       this.exceptionCount = 0;
    //       this.latestException = null;
    //       return res;
    //     } else {
    //       return null;
    //     }
    //   }
    //   catch (e: any) {
    //     console.error(e);
    //     this.exceptionCount++;
    //     if (e) {
    //       this.latestException = JSON.stringify(e);
    //     } else {
    //         this.latestException = null;
    //     }
    //   }
    // }

    /** localStorageのデータをkey, valueのペアで抽出する */
    private createLocalStorageLogs(): { key: string, value: string }[] {
        const jsonList: { key: string, value: string }[] = [];
        for (const key in localStorage) {
          if (localStorage.hasOwnProperty(key) && !this.isUnnecessaryLocalStorageKey(key)) {
            jsonList.push({key: key, value: localStorage.getItem(key)});
          }
        }
        return jsonList;
    }

    /** sessionStorageのデータをkey, valueのペアで抽出する */
    private createSessionStorageLogs(): { key: string, value: string }[] {
        const jsonList: { key: string, value: string }[] = [];
        for (const key in sessionStorage) {
          if (sessionStorage.hasOwnProperty(key)) {
            jsonList.push({key: key, value: sessionStorage.getItem(key)});
          }
        }

        return jsonList;
    }

    /** ログ出力対象のkeyであるか判定 */
    private isUnnecessaryLocalStorageKey(key: string): boolean {
        // Cognito認証用のkeyはセキュリティ的に出力したくないので対象外扱いにする
        const unnecessaryKeyPatterns: RegExp[] = [
        /^CognitoIdentityServiceProvider.*$/,
        ];
        if (unnecessaryKeyPatterns.some(pattern => pattern.test(key))) {
        return true;
        } else {
        return false;
        }
    }
  
    /** テスト用ログ出力 */
  public displayLog(str: string): void {
    // 本番環境では実行しない
    if (environment.name !== 'dev') {
      return;
    }
    // const currentDate = new Date();
    // const currentDateTimeStr = currentDate.toLocaleString('ja');
    // this.displayLogs = `[${currentDateTimeStr}]${str}\n` + this.displayLogs;
    console.log(str);
  }    
}
